import { useSelector } from 'react-redux';
import { selectUser } from 'app/store/userSlice';

function SetURL() {
   const user = useSelector(selectUser);

   return user.role === 'client' ? 'client' : 'operator';
}

export default SetURL;
